// src/components/OfflineBanner.tsx
// Full-width banner that appears when the device is offline.
// Renders at top of the viewport, pushes content down (not fixed-overlay).

import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { useOfflineDetection } from "@/hooks/useOfflineDetection";

export function OfflineBanner() {
  const { isOffline } = useOfflineDetection();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isOffline) {
      setVisible(true);
    } else {
      // Keep the banner for 1.5s after reconnecting so user sees the change
      const t = setTimeout(() => setVisible(false), 1500);
      return () => clearTimeout(t);
    }
  }, [isOffline]);

  if (!visible) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`w-full z-[200] flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium transition-colors duration-500 ${
        isOffline
          ? "bg-rose-600 text-white"
          : "bg-emerald-600 text-white"
      }`}
    >
      {isOffline ? (
        <>
          <WifiOff className="w-4 h-4 flex-shrink-0" />
          <span>Keine Internetverbindung – Calls sind offline nicht möglich.</span>
        </>
      ) : (
        <span>✓ Verbindung wiederhergestellt</span>
      )}
    </div>
  );
}
